import { BaseWidget } from './BaseWidget.js';

export class ButtonWidget extends BaseWidget {
	constructor(options) {
		super({ ...options, type: 'button' });
		this.isMinimized = false;
		this._hiddenForOpenPanel = false;
	}

	_hasTrigger() {
		return this.options.trigger === true || this.options.trigger === undefined;
	}

	_render() {
		if (!this._hasTrigger()) {
			// No built-in button — widget is opened programmatically or via custom trigger
			const placeholder = document.createElement('div');
			placeholder.style.display = 'none';
			return placeholder;
		}

		const buttonText =
			this.options.buttonText ||
			this.options.triggerText ||
			this.options.label ||
			this.options.text ||
			'Feedback';

		const button = document.createElement('div');
		button.className = `feedback-widget-button position-${this.options.position}`;
		button.innerHTML = `
      <button class="feedback-trigger-btn" type="button">
        <svg class="feedback-icon" xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 256 256">
          <path d="M224,48H32a8,8,0,0,0-8,8V192a16,16,0,0,0,16,16H216a16,16,0,0,0,16-16V56A8,8,0,0,0,224,48Zm-8,144H40V74.19l82.59,75.71a8,8,0,0,0,10.82,0L216,74.19V192Z"/>
        </svg>
        <span class="feedback-text">${buttonText}</span>
      </button>
    `;

		if (this.options.customStyles) {
			Object.assign(button.style, this.options.customStyles);
		}

		return button;
	}

	_attachEvents() {
		if (!this._hasTrigger()) return;

		const button = this.element.querySelector('.feedback-trigger-btn');

		button.addEventListener('click', () => {
			this.openPanel();
		});

		button.addEventListener('pointerup', (e) => {
			if (e.pointerType === 'mouse') return;
			this.openPanel();
		});
	}

	openPanel() {
		if (this._hasTrigger() && !this.state.isOpen) {
			this._hiddenForOpenPanel = true;
			this.hide();
		}
		super.openPanel();
	}

	closePanel() {
		const shouldRestoreButton = this._hiddenForOpenPanel;
		super.closePanel();

		if (shouldRestoreButton) {
			setTimeout(() => {
				if (!this.destroyed && !this.options._noTriggerButton) {
					this.show();
				}
				this._hiddenForOpenPanel = false;
			}, 320);
		}
	}

	mount(container) {
		super.mount(container);
	}

	updateText(text) {
		const textEl = this.element?.querySelector('.feedback-text');
		if (textEl) {
			textEl.textContent = text;
		}
	}

	updatePosition(position) {
		this.options.position = position;
		if (this.element) {
			this.element.className = this.element.className.replace(
				/position-\w+/,
				`position-${position}`
			);
		}
	}
}
